import { useCallback } from 'react';
import { useSignOutMutation } from '@/store/api';
import { clearTradeModalsStorage } from '@/hooks';
import { ROUTES } from '@/constants';

const SIGN_OUT_MUTATION_KEY = 'application-sign-out';

export const useSignOut = () => {
	const [signOut] = useSignOutMutation({ fixedCacheKey: SIGN_OUT_MUTATION_KEY });

	return useCallback(async () => {
		const signOutRequest = signOut(undefined);
		clearTradeModalsStorage();
		await signOutRequest;
		window.location.assign(ROUTES.HOME);
	}, [signOut]);
};

export const useIsSigningOut = () => {
	const [, { isLoading }] = useSignOutMutation({ fixedCacheKey: SIGN_OUT_MUTATION_KEY });

	return isLoading;
};
